<template>
	<Row class="flex-align-center">
		<component class="avatar mr-1" :is="avatarComponent" v-bind="avatarComponentProps" />
		<AppIcon v-if="showAutoUpgradeIndication" name="auto-member-upgrade" class="mr-1" />
		<Col>
			<h3 class="user-name reg">{{ name }}</h3>
			<h5 class="description-text reg" v-if="isGroup && groupFullPath != name">{{ groupFullPath }}</h5>
		</Col>
	</Row>
</template>
<script>
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar.vue';
import { groupPathItems } from '@/store/modules/accountGroups/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'ShareFeatureItemAvatarAndName',
	components: { SettingsManageUsersInfoAvatar },
	props: {
		size: { type: Number, default: 30 },
		name: { type: String, default: '' },
		item: { type: Object, default: null },
		isGroup: { type: Boolean, default: false },
		showAutoUpgradeIndication: { type: Boolean, default: false },
	},
	computed: {
		...mapGettersShorthand({ groupPathItems }),
		avatarComponent() {
			return this.isGroup ? 'AppGroupAvatar' : SettingsManageUsersInfoAvatar;
		},
		avatarComponentProps() {
			return { ...(this.isGroup ? { group: this.item } : { user: this.item }), size: this.size };
		},
		groupFullPath() {
			return this.isGroup
				? this.groupPathItems(this.item)
						.map((g) => g.name)
						.join(' > ')
				: '';
		},
	},
};
</script>
<style scoped lang="scss">
.user-name {
	color: var(--bold-title);
}
.description-text {
	opacity: 0.5;
	color: #292829;
	font-weight: 300;
}
</style>
